import { Account } from 'model/IChat';
import React, { forwardRef } from 'react';
import BookBlockDatePicker from 'reusable-components/book-block/BookBlockDateSelector/BookBlockDatePicker';
import CalendarIcon from 'reusable-components/icons/outline/CalendarIcon';
import formatDate from 'utils/formatDate';
import PopoverInput from '~/reusable-components/inputs/PopoverInput';

interface BookBlockDateSelectorProps {
  selectedDate?: string;
  onDateChange: (date: string) => void;
  availableDates: { date: string; locals: string[] }[];
  preferredLocal?: Partial<Account>;
  isLocalPicker?: boolean;
  hasAvailableSelectedDate: boolean;
  showHighlights?: boolean;
  isLoading: boolean;
}

const BookBlockDateSelector = forwardRef(
  (
    {
      selectedDate,
      onDateChange,
      availableDates = [],
      preferredLocal,
      isLocalPicker,
      hasAvailableSelectedDate,
      showHighlights,
      isLoading,
    }: BookBlockDateSelectorProps,
    ref,
  ) => {
    const formattedSelectedDay = selectedDate
      ? formatDate(selectedDate, 'PP')
      : undefined;

    return (
      <PopoverInput
        ref={ref}
        icon={CalendarIcon}
        value={formattedSelectedDay}
        placeholder="Select date"
        hasError={isLocalPicker && !hasAvailableSelectedDate}
        testId="BookBlockDateSelector"
        children={
          <BookBlockDatePicker
            selectedDate={selectedDate}
            onDateChange={onDateChange}
            availableDates={availableDates}
            preferredLocal={preferredLocal}
            showHighlights={showHighlights}
            isLoading={isLoading}
          />
        }
      />
    );
  },
);

export default BookBlockDateSelector;
